
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Meistens sind übergewichtige Männer mittleren Alters von Schlafapnoen betroffen. Ihr Schnarchen ist laut und unregelmässig, und wird von sekundenlangen Atempausen unterbrochen. Pro Nacht kann sich das bis zu mehreren hundert Mal wiederholen, vor allem dann, wenn der Schläfer auf dem Rücken liegt. Denn dann ist seine Rachenmuskulatur entspannt. Diese Apnoen sind nicht nur für die Mitschläfer(in) nervend, auch der Schläfer schreckt immer wieder aus dem Schlaf auf. Doch gefährlich sind vor allem darum, weil auf diese Weise die Tiefe des Schlafes und dessen Qualität vermindert wird. In der Folge kann es u.a. zu Tagesschläfrigkeit, Stoffwechsel-, und Herz-Kreislaufproblemen kommen. Auch Frauen können unter Apnoen leiden, allerdings zeigt sie sich diese anders als bei Männern. Laut der Lungenliga Schweiz können Kopfschmerzen, Verdauungsstörungen, Stimmungsschwankungen und Depressionen die Folge sein. Nächtliche Atemaussetzer sind bei Frauen weniger häufig als bei Männern. Risikofaktoren sind die Schwangerschaft, Übergewicht und die Zeit nach der Menopause.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;